import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PersonIcon from '@mui/icons-material/Person';
import {useTranslation} from 'react-i18next';
import TableLeads from './TableLeads';
import TableClientes from './TableClientes';
import TableAniversario from './TableAniversario';
import {getCarteirasContas,getClientesProspects} from '../../../pages/requests';
import Spinner from '../../Spinner';
import {Context} from '../../../Helpers/Auth';

function ContasLeads() {
    const {t} = useTranslation();
    const [leadsPorTratar, setLeadsPorTratar] = useState(0);
    const {utilizador} = useContext(Context);
    const [leadsClientes, setLeadsClientes] = useState({});
    const [leadsProspects, setLeadsProspects] = useState({});

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    // Loadings
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        promises.push(
            getCarteirasContas(lang).then(res => {
                if (res.data.success) {
                    setLeadsPorTratar(res.data.totalLeads);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        promises.push(
            getClientesProspects(lang).then(res => {
                if (res.data.success) {
                    if (res.data.leads.length > 0) setLeadsClientes(res.data.leads[0]);
                    if (res.data.leads.length > 1) setLeadsProspects(res.data.leads[1]);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <>
            
                <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
                    <div className="rounded-xl p-5 border bg-card dark:bg-gray-800 dark:border-gray-700 text-card-foreground shadow">
                        <div className="flex flex-row items-center justify-between space-y-0 ">
                            <h3 className=" flex flex-row items-center dark:text-gray-50 justify-between space-y-0 pb-1 -mt-2 tracking-tight text-lg font-medium">{t('numeroLeadsTratar')}</h3>
                            <div className="flex justify-center items-center w-14 h-14 bg-gray-100 dark:bg-blue-300 rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                <GroupsOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                            </div>
                        </div>
                        <div className=" pt-0">
                          
                            <div className="text-2xl font-bold dark:text-blue-500 text-blue-700">{loading ? <Spinner /> : leadsPorTratar}</div>
                        </div>
                    </div>
                    <div className="rounded-xl p-5 border bg-card dark:bg-gray-800 dark:border-gray-700 text-card-foreground shadow">
                        <div className="flex flex-row items-center justify-between space-y-0 ">
                            <h3 className=" flex flex-row items-center dark:text-gray-50 justify-between space-y-0 pb-1 -mt-2 tracking-tight text-lg font-medium">{t('numClientes')}</h3>
                            <div className="flex justify-center items-center dark:bg-blue-300 w-14 h-14 bg-gray-100 rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                <PersonIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                            </div>
                        </div>
                        <div className=" pt-0">
                            <div className="text-2xl font-bold dark:text-blue-500 text-blue-700">{leadsClientes.total}</div>
                        </div>
                    </div>
                    <div className="rounded-xl p-5 border bg-card dark:bg-gray-800 dark:border-gray-700 text-card-foreground shadow">
                        <div className="flex flex-row items-center justify-between space-y-0 ">
                            <h3 className=" flex flex-row items-center dark:text-gray-50 justify-between space-y-0 pb-1 -mt-2 tracking-tight text-lg font-medium">{t('numProspect')}</h3>
                            <div className="flex justify-center items-center dark:bg-blue-300 w-14 h-14 bg-gray-100 rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                <PersonSearchIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                            </div>
                        </div>
                        <div className=" pt-0">
                            <div className="text-2xl font-bold dark:text-blue-500 text-blue-700">{leadsProspects.total}</div>
                        </div>
                    </div>
                </div>
            
            <div>
                <TableLeads />
            </div>
            <div>
                <TableClientes leadsClientes={leadsClientes} leadsProspects={leadsProspects} loadingChart={loading} />
            </div>
            <div className="py-4">
                <TableAniversario />
            </div>
        </>
    );
}

export default ContasLeads;
